// extracted by mini-css-extract-plugin
export var content = "LoginSignupLayout-module__content___hkmZG";
export var form = "LoginSignupLayout-module__form___RvobY";
export var img = "LoginSignupLayout-module__img___J3DZ6";
export var picture = "LoginSignupLayout-module__picture___VFCfp";